import { render, staticRenderFns } from "./QuotaName.vue?vue&type=template&id=343ae158&"
import script from "./QuotaName.vue?vue&type=script&lang=js&"
export * from "./QuotaName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports